/* after changing this file run 'npm run webpack:build' */
// TODO understand why
// import '../content/scss/vendor.scss';


// import '../../../../node_modules/intl-tel-input/build/js/utils.js';
